import React from "react";
import { Calendar } from "primereact/calendar";
import { useTranslation } from "react-i18next";

const DateRangePicker = ({
  dates,
  setDates,
  range = "range",
  placeholder = "Date",
  showButtonBar = true,
}) => {
  const { t } = useTranslation();
  
  // Convert stored ISO strings back to Date objects for the Calendar
  const dateValues = Array.isArray(dates) 
    ? dates.map(d => d ? new Date(d) : null)
    : dates ? new Date(dates) : null;
  
  const hasValue = Array.isArray(dateValues) 
    ? dateValues?.some((d) => d) 
    : !!dateValues;

  const handleChange = (e) => {
    // Convert Date objects to ISO strings before storing
    const value = Array.isArray(e.value)
      ? e.value.map(d => d ? d.toISOString() : null)
      : e.value ? e.value.toISOString() : null;
    
    setDates(value);
  };

  return (
    <div className={`date_range_picker ${hasValue ? "has-value" : ""}`}>
      <Calendar
        value={dateValues}
        onChange={handleChange}
        selectionMode={range}
        readOnlyInput
        hideOnRangeSelection
        showIcon
        placeholder={t(placeholder)}
        showButtonBar={showButtonBar}
        maxDate={new Date()}
      />
    </div>
  );
};

export default DateRangePicker;
